export default __webpack_public_path__ + "static/2268-2da6477a2efb7d5c8981dc838c1edd58.gif";